import '@esnafai/shared/ui/styles.css';
import { installPrompt } from '@esnafai/shared/push';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { config } from './lib/config';
import { registerServiceWorker } from './lib/sw-register';

// Start-up (PLAN §1.3): keep the install prompt, start mock mode before the first render, register the push worker.
// Nothing here asks a permission (merchant screens §4.5).
async function start() {
  installPrompt.capture();
  if (config.mockMode) {
    const { startMockMode } = await import('@esnafai/shared/mock');
    const { mockPage } = await startMockMode({ validate: config.dev });
    if (mockPage) return; // /mock/checkout or /mock/connect: the mock's page replaced the app
  }
  void registerServiceWorker();
  const root = document.getElementById('root');
  if (root) {
    createRoot(root).render(
      <StrictMode>
        <App />
      </StrictMode>,
    );
  }
}

void start();
